export default "__VITE_ASSET__TeVv0HTC__"